import { Dropdown } from 'react-bootstrap'
import React from 'react'
import CustomDropdownToggle from '../../../custom/CustomDropdownToggle'
import Icon from 'icons/Icon'

const DateSelector = ({ label, values, onChange, options, getValue, disabled = false }) => {
  const current = getValue(values)
  return (
    <Dropdown className={`icon-left ${disabled ? 'pe-none' : ''}`}>
      <Dropdown.Toggle
        as={CustomDropdownToggle}
        id='dropdown-basic'
        style={{ background: 'rgba(0, 0, 0, 0)' }}
      >
        <Icon name='drop-arrow' className='drop-arrow-icon' />
        <div className='text-capitalize date-text'>{current}</div>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <div className='scrollDropdown'>
          {options.map((option) => (
            <Dropdown.Item
              value={option}
              key={option}
              className={String(option) === String(current) ? 'active-item' : ''}
              onClick={() => onChange(String(option), label)}
            >
              {option}
            </Dropdown.Item>
          ))}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default DateSelector
